"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Sun, Moon, Monitor } from "lucide-react";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@workspace/ui/components/toggle-group";
import { cn } from "@workspace/ui/lib/utils";

const themes = [
  { value: "system", icon: Monitor, label: "Sistema" },
  { value: "light", icon: Sun, label: "Claro" },
  { value: "dark", icon: Moon, label: "Escuro" },
] as const;

interface ThemeToggleProps {
  className?: string;
  itemClassName?: string;
}

export function ThemeToggle({ className, itemClassName }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return (
    <ToggleGroup
      type="single"
      variant="outline"
      size="sm"
      className={cn("w-full", className)}
      value={mounted ? theme : "system"}
      onValueChange={(value) => {
        if (value) setTheme(value);
      }}
      disabled={!mounted}
    >
      {themes.map(({ value, icon: Icon, label }) => (
        <ToggleGroupItem
          key={value}
          value={value}
          aria-label={`Usar tema ${label.toLowerCase()}`}
          className={cn(
            "flex-1 cursor-pointer gap-1.5 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground",
            itemClassName,
          )}
        >
          <Icon className="size-4" />
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
